import * as React from 'react';
import { Tabs } from '../components/shared';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import PageWrap from './PageWrap';

type PageWithTabsProps = StyledSystemProps & {
  color?: string;
  children: React.ReactNode;
  tabs: Array<{ to: string; title: string }>;
  renderTabs?: () => Array<{ to: string; title: string }>;
};

const PageWithTabs: React.FC<PageWithTabsProps> = props => {
  return (
    <PageWrap {...props}>
      <Tabs tabs={props.tabs} renderTabs={props.renderTabs} />
      {props.children}
    </PageWrap>
  );
};

export default PageWithTabs;

PageWithTabs.defaultProps = {
  tabs: [],
  bg: 'paleGrey',
  children: <div />,
  flexDirection: 'column',
};
